module.exports = __webpack_public_path__ + "img/yinhedesk.43faa86c.png";